import { useRef } from 'react';

export const useLastNonNull = <T>(newVal: T) => {
  const cachedVal = useRef<T>(newVal);
  const oldVal = cachedVal.current;
  cachedVal.current = newVal ?? oldVal;
  return [cachedVal.current, oldVal] as const;
};
